
/**
 * 강의 자료 요약 정보
 */
export type GetCourseDraftAssets200ContentItem = {
  /**
   * 자료 타입 (예: PDF, IMAGE 등)
   * @nullable
   */
  assetType?: string | null;
  /** 자료 다운로드 URL */
  downloadUrl: string;
  /**
   * 업로드된 파일 이름
   * @nullable
   */
  fileName?: string | null;
  /**
   * 파일 크기 (바이트)
   * @nullable
   */
  fileSize?: number | null;
  /** 자료 고유 ID */
  id: string;
  /**
   * 자료 제목
   * @nullable
   */
  title?: string | null;
  /**
   * 업로드 시각
   * @nullable
   */
  uploadedAt?: string | null;
};
